<template>
  <b-nav pills>
    <b-nav-item v-for="(text, name) in navigation" :key="name" :to="{ name }"
      :active="$route.name === name">{{ text }}</b-nav-item>
  </b-nav>
</template>

<script>
import { mapPreferences } from '@src/mixins/root';

export default {
  computed: {
    ...mapPreferences([ 'canSyncContacts', 'canScheduleLinkedInPosts' ]),
    navigation() {
      return {
        Profile: this.$t('users.your-profile-title'),
        ProfileSessions: this.$t('users.your-sessions-title'),
        // ProfileAlerts: this.$t('users.your-alerts-title'),
        ...(this.canSyncContacts ? { ProfileSyncContacts: this.$t('users.sync-contacts-title') } : {}),
        ...(this.canScheduleLinkedInPosts ? { ProfileScheduledPosts: 'Scheduled Posts' } : {}),
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/users/ProfileNav.vue